import React from 'react'
import { Box, Typography, Button } from '@mui/material'
import Section from './section'

const CampBanner = ({ styles }) => {
  return (
    <Section
      id='promo-banner'
      sx={{
        backgroundColor: styles.lightGrey,
        minHeight: { xs: '10vh', lg: '10vh' },
        position: 'relative'
      }}
    >
      <Box
        sx={{
          ...styles.box,
          color: '#fff',
          display: 'grid',
          gridTemplateColumns: '65% auto'
        }}
      >
        <Typography variant='h1' sx={{ gridColumn: '1/3' }}>
          More Camps = More Savings!
        </Typography>
        <Typography variant='h2' sx={{ gridColumn: '1/2', fontWeight: '400' }}>
        Save up to <b>20% off</b> when you register for multiple summer camps.
        </Typography>
        <Box
          sx={{
            gridColumn: '2/3',
            gridRow: '2/4',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <Button
            onClick={() => {
              window.location.pathname = '/enroll'
            }}
            variant='contained'
          >
            Enroll Now
          </Button>
        </Box>
      </Box>
    </Section>
  )
}

export default CampBanner
